const satisfiesNone = function(...classifiers) {
    return function(...values) {
        return classifiers.every(c => !c(...values));
    };
};

export default satisfiesNone;